import { Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import * as S from './InspectionForm.styles';

interface CreateAuditMenuProps {
  editing?: boolean
  onSave?: () => void
  onCreate?: () => void
  anchorEl: HTMLElement | null
  isCreateAuditMenuOpen: boolean
  handleClose: () => void
}

export const CreateAuditMenu: FC<CreateAuditMenuProps> = ({ editing = false, onCreate, onSave, anchorEl, isCreateAuditMenuOpen, handleClose }) => {
  const { t } = useTranslation()

  if(editing){
    return null
  }

  return (
    !editing && (
      <S.CreateAuditMenu open={isCreateAuditMenuOpen} onClose={handleClose} anchorEl={anchorEl}>
        <S.AuditMenuItem
          onClick={() => {
            onSave?.()
            handleClose()
          }}>
          <S.AuditMenuText>
            <Typography fontSize={16}>
              {t('Save this and Create Another one')}
            </Typography>
          </S.AuditMenuText>
        </S.AuditMenuItem>
        <S.AuditMenuItem
            onClick={() => {
            onCreate?.()
            handleClose()
          }}>
          <S.AuditMenuText>
          <Typography fontSize={16}>
              {t('Save this and Create')}
            </Typography>
          </S.AuditMenuText>
        </S.AuditMenuItem>
      </S.CreateAuditMenu>
    )
  )
  }